// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-normal-container","blocksContainer":"pages-normal-blocksContainer","title":"pages-normal-title","button":"pages-normal-button"};